import { useState } from "react";
import { getAbsoluteUrl } from "../../../utils/getAbsoluteUrl";

export interface Link {
  href: string;
  target: string | null;
  text: string | "";
}

export interface APIResult {
  linkBlocks: Link[];
}

export const useCampaignLinks = () => {
  const [links, setLinks] = useState<Link[]>([]);
  const [loading, setLoading] = useState(false);

  const getCampaignLinks = async () => {
    setLoading(true);
    const result = await fetchLinks();

    if (!result) {
      console.error("Failed to load links.");
      return false;
    }

    const fetchedLinks = result.linkBlocks;

    setLinks(fetchedLinks);
    setLoading(false);
  };

  const fetchLinks = async (): Promise<APIResult | null> => {
    try {
      // Use absolute URL base to account for if the URL doesn't end with a forward slash
      const urlBase = getAbsoluteUrl();

      const urlToFetch = `${urlBase}GetCampaignLinks`;
      const response = await fetch(urlToFetch);
      const data = await response.json();

      return {
        linkBlocks: data,
      };
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return { links, getCampaignLinks, loading };
};
